/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdAttachmentsAttachmentidDownload200,
  GetApiV1PersonIdAttachmentsAttachmentidDownload401,
  GetApiV1PersonIdAttachmentsAttachmentidDownload404,
  GetApiV1PersonIdAttachmentsAttachmentidDownload500,
  GetApiV1PersonIdAttachmentsAttachmentidDownloadPathParams,
  GetApiV1PersonIdAttachmentsAttachmentidDownloadQueryResponse,
} from "../../types/personDocumentsController/GetApiV1PersonIdAttachmentsAttachmentidDownload.ts";

export const getApiV1PersonIdAttachmentsAttachmentidDownloadPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    attachmentId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentidDownloadPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdAttachmentsAttachmentidDownload200Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentidDownload200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdAttachmentsAttachmentidDownload401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentidDownload401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdAttachmentsAttachmentidDownload404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentidDownload404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdAttachmentsAttachmentidDownload500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentidDownload500>;

export const getApiV1PersonIdAttachmentsAttachmentidDownloadQueryResponseSchema =
  z.lazy(
    () => getApiV1PersonIdAttachmentsAttachmentidDownload200Schema,
  ) as unknown as ToZod<GetApiV1PersonIdAttachmentsAttachmentidDownloadQueryResponse>;
